import React, { useState, useEffect } from "react";
import {
  Navbar,
  Container,
  Form,
  FormControl,
  Badge,
  Dropdown,
  Modal,
  Button,
  Card,
  Image,
  Spinner,
  ListGroup,
  Row,
  Col,
  ListGroupItem,
} from "react-bootstrap";
import { Search } from "react-bootstrap-icons";
import { IoIosNotificationsOutline } from "react-icons/io";
import { FiUser, FiLogOut, FiMenu, FiEdit3 } from "react-icons/fi";
import { CiSettings, CiSearch } from "react-icons/ci";
import { HiOutlineMenuAlt4 } from "react-icons/hi";
import { AiOutlineLogout } from "react-icons/ai";
import "../profile.css";
import { useAuth } from "../context/AuthContext";
import { URLS } from "../utils/URL";
import api from "../utils/helper";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { useAlerts } from "../context/AlertContext";
import { Link, useLocation, useNavigate } from "react-router-dom";

const Header = ({ onToggleSidebar }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [showProfileModal, setShowProfileModal] = useState(false);
  const handleCloseProfileModal = () => setShowProfileModal(false);
  const handleShowProfileModal = () => setShowProfileModal(true);

  const { showSuccess, showError } = useAlerts();

  const { logout } = useAuth();
  const lastUpdated = "20/01/2024";
  const userDetails = { role: localStorage.getItem("userRole") };

  const queryClient = useQueryClient();

  const {
    data: userProfile,
    isLoading,
    error,
  } = useQuery(
    ["user-profile"],
    () => api.get("/user-profile/super-admin").then((res) => res?.data),
    {
      staleTime: 5 * 60 * 1000, // Optional: cache for 5 min
    }
  );

  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({
    firstname: "",
    lastname: "",
    email: "",
    phone: "",
    profile_img: null,
  });

  useEffect(() => {
    if (userProfile) {
      setFormData({
        firstname: userProfile.firstname || "",
        lastname: userProfile.lastname || "",
        email: userProfile.email || "",
        phone: userProfile.phone || "",
        profile_img: userProfile.profile_img || null, // new
      });
    }
  }, [userProfile]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {

      const fData = new FormData();
      fData.append("file", file);
      fData.append("courseName", "profile");
      fData.append("moduleName", "profile");

      logoMutation.mutate({ fData });
    }
  };

  const handleUpdateProfile = useMutation(
    async (formData) => {
      const payload = new FormData();
      payload.append("firstname", formData.firstname);
      payload.append("lastname", formData.lastname);
      payload.append("email", formData.email);
      payload.append("phone", formData.phone);
      if (formData.profile_img) {
        payload.append("profile_img", formData.profile_img);
      }

      const method = isEditing ? "put" : "put";
      const endpoint = "/user-profile/super-admin";
      return api[method](endpoint, payload);
    },

    {
      onSuccess: (response) => {
        showSuccess(response.data?.message || "Profile updated successfully!");
        queryClient.invalidateQueries(["user-profile"]);

        setIsEditing(false);
      },
      onError: (error) => {
        showError(error?.response?.data?.message || "Failed to add Teacher: ");
        console.log("Failed to add Teacher: " + error.message);
      },
    }
  );

  const logoMutation = useMutation(

    ({ fData }) => api.upload("/upload", fData, "upload"),
    {
      onSuccess: (response) => {
        console.log(response.data?.data?.url, "milai")
        setFormData((prev) => ({ ...prev, profile_img: response.data?.data?.url }));
        // setPreviewImage(response.data?.data?.url);

        handleUpdateProfile.mutate({ ...formData, profile_img: response.data?.data?.url });
      },
      onError: (error) => {
        showError(error?.response?.data?.message || "Error uploading file:");
        console.error("Error uploading file:", error);
      },
    }
  );

  return (
    <>
      <Navbar
        variant="dark"
        expand={false}
        className="py-2 py-md-0 bgNav sticky-top headerScroll"
      >
        <Container fluid className="px-3">
          <div className="d-flex align-items-center w-100">
            {/* Drawer Icon for Mobile */}
            <div className="d-block d-lg-none me-0 menu-bg">
              {/* <FiMenu size={24} color="white" onClick={onToggleSidebar} style={{ cursor: 'pointer' }} /> */}

              <HiOutlineMenuAlt4
                size={24}
                color="white"
                onClick={onToggleSidebar}
                style={{ cursor: "pointer" }}
              />
            </div>

            {/* Logo */}
            <Navbar.Brand href="#home">
              <img
                src="/images/Group 1.png"
                className="d-inline-block align-top mobile-brand"
                alt="HyTech Didactic Logo"
              />
            </Navbar.Brand>

            {/* Profile Section - Always visible */}
            <div className="ms-auto d-flex align-items-center">
              {/* Search Bar - Only visible on desktop */}
              <div className="d-none d-lg-block mx-4">
                <Form className="d-flex">
                  <div className="position-relative w-100">
                    <FormControl
                      type="search"
                      placeholder="Search"
                      className="text-white searchBox"
                      aria-label="Search"
                    />
                    <CiSearch
                      className="position-absolute translate-middle-y mx-3 searchIcon searchLogo"
                      size={20}
                      color="#ffffff"
                    />
                  </div>
                </Form>
              </div>
              {/* Notifications - Only visible on desktop */}
              <div className="position-relative me-3 me-md-5">
                <IoIosNotificationsOutline color="#60B1FF" size={28} />
                <Badge
                  bg="light"
                  className="position-absolute top-0 start-100 translate-middle rounded-pill text-black"
                >
                  10
                </Badge>
              </div>

              {/* Profile Dropdown */}
              <Dropdown
                show={isOpen}
                onToggle={() => setIsOpen(!isOpen)}
                className="profile-toggle"
              >
                <Dropdown.Toggle className="d-flex align-items-center border-0 bg-transparent">
                  <img
                    // src="/images/Avatar.png"
                    src={
                      formData.profile_img
                        ? formData.profile_img
                        : "/images/adminProfile.png"
                    }
                    alt="Profile"
                    className="rounded-circle"
                    style={{ width: "35px", height: "35px" }}
                  />
                  <div className="ms-2 d-none d-sm-block">
                    <div className="profile-name">
                      {userProfile?.firstname} {userProfile?.lastname}
                    </div>
                    <div className="profile-role">{userDetails?.role}</div>
                  </div>
                </Dropdown.Toggle>

                <Dropdown.Menu align="end" className="shadow border-0">
                  <div className="d-flex align-items-center px-3 py-2">
                    <img
                      // src="/images/Avatar.png"
                      src={
                        formData.profile_img
                          ? formData.profile_img
                          : "/images/adminProfile.png"
                      }
                      alt="User"
                      className="rounded-circle me-2"
                      width="40"
                      height="40"
                    />
                    <div>
                      <div className="fw-bold">
                        {userProfile?.firstname} {userProfile?.lastname}
                      </div>
                      <div className="text-muted small">
                        {userProfile?.email}
                      </div>
                    </div>
                  </div>
                  <Dropdown.Divider />
                  <Dropdown.Item
                    className="d-flex align-items-center textView"
                    onClick={handleShowProfileModal}
                  >
                    <FiUser className="me-2" size={20} />
                    View Profile
                  </Dropdown.Item>
                  <Dropdown.Item className="d-flex align-items-center textView">
                    <Link
                      to="/setting"
                      style={{ color: "black", textDecoration: "none" }}
                    >
                      <CiSettings className="me-2" size={20} />
                      Settings
                    </Link>
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={() => logout()}
                    className="d-flex align-items-center text-danger textOut"
                  >
                    <FiLogOut className="me-2" color="#E9432D" size={20} />
                    Log Out
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>
        </Container>
      </Navbar>

      <div className="d-block d-lg-none px-3 bgNav py-3">
        <Form className="d-flex">
          <div className="position-relative w-100 searching">
            <FormControl
              type="search"
              placeholder="Search"
              className="text-white searchBox"
              aria-label="Search"
            />
            <CiSearch
              className="position-absolute translate-middle-y mx-3 searchIcon  searchImage"
              size={20}
            />
          </div>
        </Form>
      </div>

      {/* Profile Modal */}

      <Modal
        show={showProfileModal}
        onHide={handleCloseProfileModal}
        dialogClassName="modal-left"
        className="stus profile"
      >
        <Modal.Header closeButton onClick={() => setShowProfileModal(false)}>
          <Modal.Title className="suggestedCourse">Profile</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Image src="/images/bgProfile.png" />
          <div className="bgImages align-items-center position-absolute flex-column ">
            <div className="bgprofile">
              <Col xs={12} md={8} className="d-flex justify-content-center">
                <div className="d-flex logoes">
                  <Image
                    src="/images/hytechLogo.png"
                    className="logoTech "
                    alt="Hytech Logo"
                  />
                </div>
                {/* <div className="d-flex logoes">
                    <Image src="/images/bajajLogo.png" alt="Bajaj Logo" />
                  </div> */}
              </Col>
            </div>
          </div>

          <Card className="p-4 text-center shadow-sm">
            <div className="d-flex justify-content-center profileLogo">
              <Image
                // src="/images/adminProfile.png" // Replace with actual profile image
                src={
                  formData.profile_img
                    ? formData.profile_img
                    : "/images/adminProfile.png"
                }
                roundedCircle
                width={100}
                height={100}
                className="border"
              />
              {/* {isEditing && ( */}
              <>
                <label
                  htmlFor="imageUpload"
                  className="editIcon position-absolute"
                // style={{
                //   bottom: "99px",
                //   right: "431px",
                //   cursor: "pointer",
                // }}
                >
                  <FiEdit3
                    size={20}
                    className="editIcon"
                    style={{ cursor: "pointer" }}
                  />
                </label>
                <input
                  id="imageUpload"
                  type="file"
                  accept="image/*"
                  onChange={handleImageChange}
                  style={{ display: "none" }}
                />
              </>
              {/* )} */}
            </div>
            {/* <Image src="/images/bgProfile.png" /> */}
          </Card>

          <Container style={{ paddingBottom: "0px" }}>
            {/* Profile Details */}
            {isLoading ? (
              <div className="text-center mt-4">
                <Spinner animation="border" />
              </div>
            ) : error ? (
              <p className="text-danger text-center mt-4">
                Failed to load profile.
              </p>
            ) : (
              <Row className="mt-4">
                {/* Basic Details */}
                <Col md={6}>
                  <Card className="mb-3 basicProfile px-3">
                    <div className="p-3 d-flex justify-content-between align-items-center">
                      <h5 className="mb-0 basicDetails">Basic Details</h5>
                      <Button
                        variant="outline-secondary"
                        className="btnEditIcon"
                        onClick={() => setIsEditing(!isEditing)}
                      >
                        <FiEdit3 size={14} color="#000000" />{" "}
                        <span className="d-md-block d-none">
                          {" "}
                          {isEditing ? "Cancel" : "Edit"}
                        </span>
                      </Button>
                    </div>
                    <div>
                      {isEditing ? (
                        <Form className="p-2 formMain">
                          <Row>
                            <Form.Group className="mb-2">
                              <Form.Label className="d-flex align-items-start text-start">
                                Name
                              </Form.Label>
                              <Form.Control
                                type="text"
                                name="name"
                                value={`${formData.firstname} ${formData.lastname}`}
                                onChange={(e) => {
                                  const [firstname, ...rest] =
                                    e.target.value.split(" ");
                                  const lastname = rest.join(" ");
                                  setFormData((prev) => ({
                                    ...prev,
                                    firstname,
                                    lastname,
                                  }));
                                }}
                              />
                            </Form.Group>

                            <Form.Group className="mb-2">
                              <Form.Label className="d-flex align-items-start text-start">
                                Email
                              </Form.Label>
                              <Form.Control
                                type="email"
                                name="email"
                                value={formData.email}
                                onChange={handleInputChange}
                              />
                            </Form.Group>
                            <Form.Group className="mb-2">
                              <Form.Label className="d-flex align-items-start text-start">
                                Phone
                              </Form.Label>
                              <Form.Control
                                type="text"
                                name="phone"
                                value={formData.phone}
                                onChange={handleInputChange}
                              />
                            </Form.Group>

                            <Button
                              color="#60B1FF"
                              className="ms-2 "
                              onClick={() =>
                                handleUpdateProfile.mutate(formData)
                              }
                              disabled={handleUpdateProfile.isLoading}
                            >
                              {handleUpdateProfile.isLoading
                                ? "Saving..."
                                : "Save Changes"}
                            </Button>
                          </Row>
                        </Form>
                      ) : (
                        <ListGroup variant="flush align-items-start text-start">
                          <ListGroupItem className="textRole">
                            <span className="details">Name:</span> <br />
                            <span className="basic">
                              {" "}
                              {userProfile?.firstname} {userProfile?.lastname}
                            </span>
                          </ListGroupItem>
                          <ListGroupItem className="textRole">
                            <span className="details">Email:</span>
                            <br />
                            <span className="basic"> {userProfile?.email}</span>
                          </ListGroupItem>
                          <ListGroupItem className="textRole">
                            <span className="details">Phone:</span>
                            <br />
                            <span className="basic">{userProfile?.phone}</span>
                          </ListGroupItem>
                          <ListGroupItem className="textRole">
                            <span className="details">Role:</span>
                            <br />
                            <span className="basic">{userDetails?.role}</span>
                          </ListGroupItem>
                        </ListGroup>
                      )}
                    </div>
                  </Card>
                </Col>

                {/* Account Security */}
                <Col md={6}>
                  <Card className="mb-3 basicProfile px-3">
                    <div className="p-3 d-flex justify-content-between align-items-center">
                      <h5 className="mb-0 basicDetails">Account Security</h5>
                      <Button
                        variant="outline-secondary"
                        className="btnEditIcon"
                      >
                        <FiEdit3 size={14} color="#000000" />{" "}
                        <span className="d-md-block d-none"> Edit</span>
                      </Button>
                    </div>
                    <div>
                      <div className="textRole p-3 text-start">
                        <h6 className="details">Password</h6>
                        <p className="basic">********************</p>
                        <p className="text-muted lastUpdate">
                          Last updated on: {lastUpdated}
                        </p>
                      </div>
                    </div>
                  </Card>

                  {/* FAQs */}
                  {/* <Row className="mt-4">
                  <Col>
                    <Card className="shadow-sm basicProfile">
                      <Card.Body>
                        <h5 className="basicDetails">FAQs</h5>
                        <Accordion className="faqQuestion">
                          <Accordion.Item eventKey="0">
                            <Accordion.Header>
                              How do I update my profile?
                            </Accordion.Header>
                            <Accordion.Body>
                              Click on the "Edit" button next to your profile
                              details and update the required information.
                            </Accordion.Body>
                          </Accordion.Item>

                          <Accordion.Item eventKey="1">
                            <Accordion.Header>
                              Can I change my email address?
                            </Accordion.Header>
                            <Accordion.Body>
                              No, your email address is linked to your account.
                              Contact support for assistance.
                            </Accordion.Body>
                          </Accordion.Item>

                          <Accordion.Item eventKey="2">
                            <Accordion.Header>
                              How do I reset my password?
                            </Accordion.Header>
                            <Accordion.Body>
                              Go to settings, click "Change Password," and
                              follow the instructions.
                            </Accordion.Body>
                          </Accordion.Item>
                        </Accordion>
                      </Card.Body>
                    </Card>
                  </Col>
                </Row> */}
                </Col>
              </Row>
            )}

            <div className="text-center mt-4 mb-4">
              <Button
                variant="danger"
                className="btnLogouts"
                onClick={() => logout()}
              >
                <AiOutlineLogout color="#C53737" size={20} className="me-2" />
                Logout
              </Button>
            </div>
          </Container>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Header;
